const hospitalMasters = [
    { label: "Maintenance Year Details", path: '/maintenanceyear', code: "ENGM001" },
    { label: "Work Group", path: '/workgroup', code: "ENGM003" },
    { label: "Standard Task Details", path: '/standardtask', code: "ENGM004" },
    { label: "Asset Category", path: '/assetcategory', code: "ENGM018" },
    { label: "Asset Type Code", path: '/assettypecode', code: "ENGM005" },
    { label: "Hospital Information", path: '/hospitalinformation', code: "ENGM006" },
    { label: "User Department", path: '/userdepartment', code: "ENGM007" },
    { label: "User Location", path: '/userlocation', code: "ENGM008" },
    { label: "License Type Code", path: '/licensetypecode', code: "ENGM009" },
    { label: "License Certificate Details", path: '/licensecertificate', code: "ENGM010" },
    { label: "Calibration Certificate Details", path: '/callibration', code: "ENGM011" },
    { label: "PPM Checklist", path: '/ppmchecklist', code: "ENGC002" },

]
const maintenance = [
    { label: "Department Work Request", path: '/departmentworkrequest', code: "ENGT010" },
    { label: "FEMS Technical Drawing", path: '/femsdrawing', code: "ENGT006" },
    { label: " Work Order Management", path: '/workorder', code: "ENGT001" },
    { label: "PPM Planner", path: '/ppmplanner', code: "ENGT002" },
    { label: "PPM Generation", path: '/ppmgeneration', code: "ENGT003" },
    { label: "Work Order Reschedule", path: '/workOrderReschedule', code: "ENGT004" },
    { label: "Routine Inspection", path: '/routineInspection', code: "RIPT001" },
    { label: "Scheduled Corrective Maintenance", path: '/scm', code: "SCMT001" },
    { label: "Predictive Maintenance", path: '/predictiveMaintenance', code: "PRMT001" },


]
const assets = [
    { label: "Testing & Commissioning", path: '/testingcommission', code: "TNCG001" },
    { label: "Asset Register - BEMS", path: '/assetsBEM', code: "ENGM014" },
    { label: "Asset Register - FEMS", path: '/assetsFEM', code: "ENGM013" },
    { label: "Asset Condition", path: '/assetcondition', code: "ENGM013A" },
    { label: "Generate Asset QR Code", path: '/assetqrcode', code: "ENGM013C" },
    { label: "Asset Service Change", path: '/assetservicechange', code: "ENGT007" },
]
const staff = [
    { label: "Staff Details", path: '/staffdetails', code: "ENGM002" },
   { label: "Staff Duty Roster", path: '/staffdutyroster', code: "SDRT001" },

]
const calendar = [
    { label: "Maintenance Calendar", path: '/maintenancecalendar', code: "ENGA006" },
]

const inventory = [
    { label: "Item Details", path: '/itemdetails', code: "IMSM005" },
    { label: "Store Details", path: '/storedetails', code: "IMSM001" },
    { label: "Stock Register", path: '/stockregister', code: "STRG001" },

]
const vendor = [
    { label: "Vendor Details", path: '/vendordetails', code: "POMM002" },
]
const contract = [
    { label: "Contract Management", path: '/contractmanagement', code: "ENGT005" },
]
const reports = {
    workOrder: [
        { label: "Work Order Analysis", path: '/WorkOrderreport', code: "ENGA001" },
        { label: "PPM Calendar ", path: '/ppmcalendar', code: "ENGA001" },],

    asset: [
        { label: "Asset Analysis", path: '/AssetAnalysisreport', code: "ENGA002" },
        { label: "Asset Condition Appraisal Report", path: '/conditionfilereport', code: "ENGA003" },
        { label: "Asset Life Cycle Cost Analysis", path: '/assetlifecyclereport', code: "ENGA004" },

    ],
    staff: [
        { label: "Staff Performance Report", path: '/staffperformance', code: "SDRT002" },
        { label: "Staff Efficiency Report", path: '/staffefficiency', code: "SDRT003" },

    ],
    others: [
        { label: "KPI PPM", path: '/kpippmreport', code: "ENGA009A" },
        { label: "KPI Repair Time", path: '/kpirepairreport', code: "ENGA009B" },
        { label: "KPI Response Time", path: '/kpiresponsereport', code: "ENGA009C" },
        { label: "Contract Register", path: '/contractoutregister', code: "ENGA008" },
        { label: "Quality Improvement Analysis", path: '/qualityimprovement', code: "ENGA009" },
        { label: "Stock Analysis", path: '/stockanalysis', code: "STRA001" },
    ]
}
const options = [
    { label: "Document Serial Number", path: '/documentserialnumber', code: "ENGO001" },
    { label: "Change Password", path: '/changepassword', code: "ENGO002" },
    { label: "Unblock User", path: '/unblockuser', code: "ENGUS001" },
    { label: "User Registration", path: '/user', code: "ENGUS001" },


]
export {
    hospitalMasters,
    maintenance,
    assets,
    staff,
    inventory,
    vendor,
    contract,
    reports,
    options,
    calendar
}